import * as React from 'react';
import { Paragraph1 } from '@cian/ui-kit/typography';

export const Price: React.FC = props => {
  return <Paragraph1 fontWeight="700">{props.children}</Paragraph1>;
};

Price.displayName = 'Price';
